import { keyBy } from 'lodash'
import { createSelector } from 'reselect'
import { getGenderByPathname } from 'common/helpers'

import messages from './messages'


const filterTags = (tags = {}, activeTags) => (str) =>
  str.split(' ').map((name) => {
    let data = tags[name]

    if (!data) {
      return null
    }

    return {
      ...data,
      value:  activeTags.includes(data.id),
    }
  })

const getItems = (isCategories, gender, tagsList, activeTags) => {
  // TODO describe this!
  // index array by function result
  const tagsByGender  = keyBy(tagsList[gender], ({ name }) => name.toLowerCase().replace(' ', '_'))
  const _filterTags   = filterTags(tagsByGender, activeTags)

  if (isCategories) {
    if (gender === 'female') {
      return [
        { title: messages.scentType, tags: _filterTags('floral fruity woody citrusy aquatic spicy') },
        { title: messages.scentPersonality, tags: _filterTags('sexy mysterious classic elegant flirty clean') },
        { title: messages.occasion, tags: _filterTags('office date_night party everyday vacation workout') },
        { title: messages.other, tags: _filterTags('fresh powdery light warm sweet strong') },
        { title: messages.season, tags: _filterTags('spring summer fall winter') },
      ]
    }

    return [
      { title: messages.scentType, tags: _filterTags('citrusy spicy fresh woody') },
      { title: messages.style, tags: _filterTags('classic adventurous casual trendsetter') },
      { title: messages.occasion, tags: _filterTags('workout date_night office hanging_out') },
    ]
  }

  if (gender === 'female') {
    return _filterTags('floral fruity woody citrusy aquatic spicy sexy mysterious classic elegant flirty clean')
  }

  return [
    { title: messages.scentType, tags: _filterTags('citrusy spicy fresh woody') },
    { title: messages.style, tags: _filterTags('classic adventurous casual trendsetter') },
    { title: messages.occasion, tags: _filterTags('workout date_night office hanging_out') },
  ]
}

const tagsSelector = (state) => state.view.smartSearchPage.filters.tags
const activeTagsSelector = (state) => state.view.smartSearchPage.activeFilters.tags

const getSmartSearchTags = createSelector(
  (state) => getGenderByPathname(state),
  tagsSelector,
  activeTagsSelector,
  (gender, tags, activeTags) => getItems(false, gender, tags, activeTags)
)

const getSmartSearchTagsByCategories = createSelector(
  (state) => getGenderByPathname(state),
  tagsSelector,
  activeTagsSelector,
  (gender, tags, activeTags) => getItems(true, gender, tags, activeTags)
)


export {
  getSmartSearchTags,
  getSmartSearchTagsByCategories,
}
